import React from "react";
import {
  Apple,
  Facebook,
  Instagram,
  LocationOn,
  Pinterest,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import { FaGooglePlay } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const socialIcons = [
    { Icon: Instagram, color: "#E4405F" },
    { Icon: Facebook, color: "#1877F2" },
    { Icon: Twitter, color: "#1DA1F2" },
    { Icon: Pinterest, color: "#BD081C" },
    { Icon: YouTube, color: "#FF0000" },
  ];

  const appIcons = [
    // { Icon: Apple, color: "#000000", label: "App Store" },
    { Icon: FaGooglePlay, color: "#0F9D58", label: "Google Play" },
  ];

  const quickLinks = [
    { to: "/about", label: "About Us" },
    { to: "/privacy-policy", label: "Privacy Policy" },
    { to: "/faq", label: "FAQs" },
    { to: "/terms-conditions", label: "Terms and Conditions" },
    { to: "/cancellation-policy", label: "Cancellation Policy" },
    { to: "/refundPage", label: "Refund Policy" },
    { to: "/ShippingPolicy", label: "Shipping & Delivery Policy" },
  ];

  const categories = [
    "Salon At Home",
    "Spa At Home",
    "Advance Facials",
    "Male Spa",
    "Male Grooming",
    "Hair Studio",
  ];

  return (
    <footer className="bg-dark text-white pt-5 pb-3 d-none d-md-block">
      <div className="container">
        {/* Main Footer Content */}
        <div className="row g-4">
          {/* Company Info */}
          <div className="col-lg-4 col-md-6">
            <h5 className="fw-bold text-warning mb-4 text-start">Saloon Treat</h5>
            <div className="d-flex align-items-start mb-3">
              <LocationOn className="text-warning mt-1 me-2" />
              <p className="text-light mb-0 small">
                1209 Mig chitrapuri hills, Khaja guda, Hyderabad, 500089
              </p>
            </div>

            {/* Social Media */}
            <div className="mb-4 ">
              <h6 className="fw-semibold mb-3 text-start">Follow Us</h6>
              <div className="d-flex gap-3">
                {socialIcons.map(({ Icon, color }, index) => (
                  <div
                    key={index}
                    className="bg-secondary bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px", cursor: "pointer" }}
                  >
                    <Icon style={{ color, fontSize: "20px" }} />
                  </div>
                ))}
              </div>
            </div>

            {/* App Download */}
            <div>
              <h6 className="fw-semibold mb-3 text-start">Get Our App</h6>
              <div className="d-flex gap-2">
                {appIcons.map(({ Icon, color, label }, index) => (
                  <button
                    key={index}
                    className="btn btn-outline-light btn-sm d-flex align-items-center px-3 py-2"
                  >
                    <Icon className="me-2" style={{ color }} />
                    <div className="text-start">
                      <div className="small">{label}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h6 className="fw-bold text-warning mb-3 text-start">Company</h6>
            <ul className="list-unstyled">
              {quickLinks.map((link, index) => (
                <li key={index} className="mb-2">
                  <Link
                    to={link.to}
                    className="text-decoration-none text-light small"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold text-warning mb-3 text-start">Services</h6>
            <ul className="list-unstyled">
              {categories.map((category, index) => (
                <li key={index} className="mb-2">
                  <span className="text-light small cursor-pointer">
                    {category}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Support */}
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold text-warning mb-3 text-start">Support</h6>
            <ul className="list-unstyled mb-4">
              <li className="mb-2">
                <Link
                  to="/contact-us"
                  className="text-decoration-none text-light small"
                >
                  Contact Us
                </Link>
              </li>
              <li className="mb-2">
                <a
                  href="mailto:info@salontreat.com"
                  className="text-decoration-none text-light small"
                >
                  info@salontreat.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <hr className="my-4 border-secondary" />

        {/* Copyright Section */}
        <div className="row align-items-center">
          <div className="col-md-8">
            <p className="text-light small mb-2 mb-md-0">
              Copyright 2024 @SaloonTreat | Powered by: Dexterous Technology.
              All rights reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
